export const login = {
  registerButton: 'Kostenlos registrieren',
  forgotPasswordLink: 'Passwort vergessen?',
  passwordRepitition: 'Passwort wiederholen',
  loginFailed: 'Login fehlgeschlagen',
}
